import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import AppActions from '../../app/app_actions';
import * as agui from 'arm-gui/dist/controls';
import Rest from '../../webapi/Rest';
import { Utils, UiUtils, NumberFormatter, DateFormatter, i18n, opt, isAuth, domain } from 'arm-common';
import ApplicationData from '../../app/aApplicationData'
import * as Layout from "arm-core-layouts";
import { isNullOrUndefined } from 'util';
import ProdottoActions from './prodotto_actions';

class ProdottoDetailsCard extends React.Component {

    constructor(props) {
        super(props);
        this.componentName = '[ProdottoDetailsCard.jsx] ';
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');
        this.props.getListaSegnelatori();
    }


    render() {
        console.log(this.componentName + "render  ");

        let descRiscLloyds = "";
        if (this.props.prodotto.idRischioLloyds != null) {
            let riscLloyds = domain('LISTA_RISCHIO_LLOYDS').find(r => r.valCampo == this.props.prodotto.idRischioLloyds);
            console.log(riscLloyds);
            if (riscLloyds != null && riscLloyds != undefined) {
                descRiscLloyds = riscLloyds.desDom;
            }
        }

        return (
            <div>

                <Layout.VBox>


                    <div className="row rowProdotto">


                        <div className="col-2"  >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome')}>
                                <b>   {this.props.prodotto.nome}</b>
                            </agui.aFieldset>
                        </div>

                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.MICRO_CATEGORIA', 'Micro-categoria')} >
                                {this.props.prodotto.microCategoria ? <button type="button" className="btn btn-link p-0" onClick={this.props.microCategoriaDetailsButton}><span style={{ fontSize: "13px" }} >{this.props.prodotto.microCategoria.nome}</span> </button> : null}
                            </agui.aFieldset>
                        </div>

                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.STATO', 'Stato')}>
                                <b>   {this.props.prodotto.stato ? ApplicationData.domainVal('AI_STATO_PRODOTTO', this.props.prodotto.stato).desDom : "-"}</b>
                            </agui.aFieldset>
                        </div>
                        <div className="col-4" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}>
                                <b>  {this.props.prodotto.descrizione} </b>
                            </agui.aFieldset>
                        </div>
                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.ORDINE', 'Ordine Visibilità')}>
                                <b>   {this.props.prodotto.ordine}</b>
                            </agui.aFieldset>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-2 ">
                            {this.props.prodotto.imagePath ?
                                <img style={{ paddingLeft: 0, paddingRight: 0, height: "150px", width: "400px", border: "2px solid  #dee2e6" }} className=" col-12 mt-2 ml-4" sizes="50x32" rel="icon" src={this.props.prodotto.imagePath ? Rest.createRestLink("document/download/" + this.props.prodotto.imagePath) : ""} alt="Card image cap" />

                                : <h6 className="mt-4">{i18n('ARM_CORE_PRODUCT.IMAGGE', 'Nessuna immagine legata a questo prodotto')}</h6>}
                        </div>
                        <div className="col-4 ">
                            <Layout.VBox colWidth={3}>
                                <div className="row rowProdotto">
                                    {this.props.prodotto.flAssicurazioneCongiunta === false ?
                                        <div className="col-6" colWidth={4} >
                                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia')}>
                                                <b>      {this.props.prodotto.prodottoCmpPojo && this.props.prodotto.prodottoCmpPojo.compagnia ? this.props.prodotto.prodottoCmpPojo.compagnia.denominazione : "-"} </b>
                                            </agui.aFieldset>
                                        </div>
                                        :
                                        <div className="col-6" colWidth={4} >
                                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia')} >
                                                {this.props.prodotto?.listaProdottoCmpPojo?.map((element, index) => {
                                                    if (element !== null && element !== undefined && element.compagnia !== undefined && element.compagnia !== null) {
                                                        return <><span className="textSize">{element.compagnia.denominazione}</span></>
                                                    }
                                                })}
                                            </agui.aFieldset>
                                        </div>
                                    }
                                    <div className="col-6" colWidth={4} >
                                        <agui.aFieldset style={{ fontWeight: "bold" }} title={i18n('ARM_CORE_PRODUCT.PRODOTTO.PUNTO_VENDITA', 'Punto Vendita')}>
                                             <b>    {this.props.prodotto.prodottoCmpPojo && this.props.prodotto.prodottoCmpPojo.puntoVendita ? this.props.prodotto.prodottoCmpPojo.puntoVendita.denominazione : "-"}</b>
                                        </agui.aFieldset>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6" colWidth={4} >
                                        <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.INIZIO_VALIDITA', 'Inizio Validità')}>
                                            <b>  {DateFormatter.dataFormatterShort(this.props.prodotto.inizioValidita)}</b>
                                        </agui.aFieldset>
                                    </div>
                                    <div className="col-6" colWidth={4} >
                                        <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.FINE_VALIDITA', 'Fine Validità')}>
                                            <b> {DateFormatter.dataFormatterShort(this.props.prodotto.fineValidita)}</b>
                                        </agui.aFieldset>
                                    </div>
                                </div>
                            </Layout.VBox>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-6">
                            <agui.Accordion
                                className=""
                                disabled={false}
                                loading={false}
                                marginBottom="12 px"
                            >
                                <agui.AccordionHeader
                                    className=""
                                    closeIcon="fa fa-chevron-down"
                                    openIcon="fa fa-chevron-up"
                                >
                                    {i18n('ARM_CORE_PRODUCT.PRODOTTO.VERSIONI', 'Versioni')}
                                </agui.AccordionHeader>
                                <agui.AccordionBody >
                                    <div className="row">
                                        <div className="col-6" colWidth={4} >
                                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.VERSIONE', 'Versione')}>
                                                <b> {this.props.prodotto.nomeVersione}</b>
                                            </agui.aFieldset>
                                        </div>
                                        <div className="col-6" colWidth={4} >
                                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.VERSIONE_PRECEDENTE', 'Versione Precedente')}>
                                                {this.props.prodotto.prodottoPadre ? <button type="button" className="btn btn-link p-0"
                                                    onClick={this.prodottoPadreDetailsButton}> {this.props.prodotto.prodottoPadre.datiVersioneProdotto} </button> : "-"}
                                            </agui.aFieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.SHARED.VERSIONE_SUCCESSIVA', 'Versione Successiva')}>
                                            {this.props.prodotto.prodottoFiglio ? <button type="button" className="btn btn-link p-0"
                                                onClick={this.prodottoFiglioDetailsButton}>{this.props.prodotto.prodottoFiglio.datiVersioneProdotto}</button> : "-"}
                                        </agui.aFieldset>
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.SHARED.VERSIONE_ORIGINE', 'Versione Origine')}>
                                            {this.props.prodotto.prodottoOrigine ? <button type="button" className="btn btn-link p-0"
                                                onClick={this.prodottoOrigineDetailsButton}>{this.props.prodotto.prodottoOrigine.datiVersioneProdotto}</button> : "-"}
                                        </agui.aFieldset>
                                    </div>

                                </agui.AccordionBody>
                            </agui.Accordion>
                        </div>
                        <div className="col-6">
                            <agui.Accordion
                                className=""
                                disabled={false}
                                loading={false}
                                marginBottom="12 px"
                            >
                                <agui.AccordionHeader
                                    className=""
                                    closeIcon="fa fa-chevron-down"
                                    openIcon="fa fa-chevron-up"
                                >

                                    <b> {i18n('ARM_CORE_PRODUCT.PRODOTTO.SERVIZI', 'Servizi')}</b>
                                </agui.AccordionHeader>
                                <agui.AccordionBody >
                                    <div className="row ">
                                        {opt("APP", "DO_PRINT", "false") === "TRUE" &&
                                            <div className="col-6" colWidth={4} >
                                                <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.SERVIZIO_DO_PRINT', 'Servizio DoPrint')}>
                                                    <b>    {this.props.prodotto.flServizioDoPrint ? "SI" : "NO"}</b>
                                                </agui.aFieldset>
                                            </div>}
                                        {opt("APP", "FIRMA_DIGITALE", "false") === "TRUE" &&
                                            <div className="col-6" colWidth={4} >
                                                <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.SERVIZIO_MAIL_FIRMA_DIGITALE', 'Servizio Mail Firma Digitale')}>
                                                    <b> {this.props.prodotto.flMailFirmaDigitale ? "SI" : "NO"} </b>
                                                </agui.aFieldset>
                                            </div>}
                                    </div>
                                    <div className="row ">
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.TACITO_RINNOVO', 'Tacito Rinnovo')}>
                                            <b>{this.props.prodotto.flTacitoRinnovo ? "SI" : "NO"} </b>
                                        </agui.aFieldset>
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.STAMPA_CERTIFICATO', 'Stampa Certificato')}>
                                            <b> {this.props.prodotto.flStampaCertificato ? "SI" : "NO"} </b>
                                        </agui.aFieldset>
                                    </div>
                                    <div className="row ">
                                        {opt("APP", "FL_VIEW_ADEGUATEZZA_ESTERNA", "false") === "true" &&
                                            <div className="col-6" colWidth={4} >
                                                <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.ADEGUATEZZA_ESTERNA', 'Adeguatezza Esterna')}>
                                                    <b> {this.props.prodotto.flAdeguatezzaEsterna ? "SI" : "NO"} </b>
                                                </agui.aFieldset>
                                            </div>}
                                        {opt("APP", "FL_VIEW_TITOLO_ANTICIPATO", "false") === "true" &&
                                            <>
                                                <div className="col-6" colWidth={4} >
                                                    <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.TITOLO_ANTICIPATO', 'Titolo anticipato')}>
                                                        <b> {this.props.prodotto.flTitoloAnticipato ? "SI" : "NO"} </b>
                                                    </agui.aFieldset>
                                                </div>

                                                <div className="col-6" colWidth={4} >
                                                    <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.INCASSO_CON_EFFETTO', 'Data incasso coincide con data effetto')}>
                                                        <b> {this.props.prodotto.flIncassoConEffetto ? "SI" : "NO"} </b>
                                                    </agui.aFieldset>
                                                </div>
                                            </>

                                        }
                                    </div>

                                </agui.AccordionBody>
                            </agui.Accordion>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <agui.Accordion
                                className=""
                                disabled={false}
                                loading={false}
                                marginBottom="12 px"
                            >
                                <agui.AccordionHeader
                                    className=""
                                    closeIcon="fa fa-chevron-down"
                                    openIcon="fa fa-chevron-up"
                                >
                                    <b> {i18n('ARM_CORE_PRODUCT.PRODOTTO.PERCENTUALI', 'Percentuali')}</b>
                                </agui.AccordionHeader>
                                <agui.AccordionBody >
                                    <div className="row">
                                        <div className="col-6" colWidth={4} >
                                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_ACCESORI', '% Accessori')}>
                                                <b>  {this.props.prodotto.percAccessori ? this.props.prodotto.percAccessori : "-"} </b>
                                            </agui.aFieldset>
                                        </div>
                                        <div className="col-6" colWidth={4} >
                                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_SPECIAL_CHARGE', '% Special Charge')}>
                                                <b> {this.props.prodotto.specialCharge ? this.props.prodotto.specialCharge : "-"} </b>
                                            </agui.aFieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_ACCESORI_MIN', '% Accessori Minimale')}>
                                            <b> {this.props.prodotto.accessoriMin ? this.props.prodotto.accessoriMin : "-"} </b>  </agui.aFieldset>
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.SPECIAL_CHARGE_MIN', '% Special Charge Minimale')}>
                                            <b>  {this.props.prodotto.specialChargeMin ? this.props.prodotto.specialChargeMin : "-"}</b>
                                        </agui.aFieldset>
                                    </div>
                                    <div className="row">
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_ACCESORI_MAX', '% Accessori Massimale')}>
                                            <b>       {this.props.prodotto.accessoriMax ? this.props.prodotto.accessoriMax : "-"} </b>  </agui.aFieldset>
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.SPECIAL_CHARGE_MAX', '% Special Charge Massimale')}>
                                            <b>  {this.props.prodotto.specialChargeMax ? this.props.prodotto.specialChargeMax : "-"}</b>
                                        </agui.aFieldset>
                                        {opt("APP", "VIEW_PERC_BONUS", "false") === "true" &&
                                            <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.PERC_BON', '% Percentuale Bonus')}>
                                                <b> {this.props.prodotto.percBonus ? this.props.prodotto.percBonus : "-"} </b>  </agui.aFieldset>}
                                    </div>

                                </agui.AccordionBody>
                            </agui.Accordion>
                        </div>
                        <div className="col-6">
                            <agui.Accordion
                                className=""
                                disabled={false}
                                loading={false}
                                marginBottom="12 px"
                            >
                                <agui.AccordionHeader
                                    className=""
                                    closeIcon="fa fa-chevron-down"
                                    openIcon="fa fa-chevron-up"
                                >
                                    {i18n('ARM_CORE_PRODUCT.PRODOTTO.CONTRATTO', 'Contratto')}
                                </agui.AccordionHeader>
                                <agui.AccordionBody >
                                    <div className="row">
                                        <div className="col-6" colWidth={4} >
                                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DURATA_MIN', 'Giorni Durata Min')}>
                                                <b>  {this.props.prodotto.ggDurataMin ? this.props.prodotto.ggDurataMin : "-"} </b>
                                            </agui.aFieldset>
                                        </div>
                                        <div className="col-6" colWidth={4} >
                                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DURATA_MAX', 'Giorni Durata Max')}>
                                                <b>    {this.props.prodotto.ggDurataMax ? this.props.prodotto.ggDurataMax : "-"} </b>
                                            </agui.aFieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DECORRENZA_MIN', 'Giorni Decorrenza Min')}>
                                            <b>  {this.props.prodotto.ggDecorrezzaMin ? this.props.prodotto.ggDecorrezzaMin : "-"} </b>
                                        </agui.aFieldset>
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DECORRENZA_MAX', 'Giorni Decorrenza Max')}>
                                            <b> {this.props.prodotto.ggDecorrezzaMax ? this.props.prodotto.ggDecorrezzaMax : "-"} </b>
                                        </agui.aFieldset>
                                    </div>
                                    <div className="row">
                                        <div className="col-6" colWidth={4} >
                                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DECORRENZA_MIN_RINNOVI', 'Giorni Decorrenza Min Rinnovi')}>
                                                <b> {this.props.prodotto.ggDecorrezzaMinRinnovi ? this.props.prodotto.ggDecorrezzaMinRinnovi : "-"} </b>
                                            </agui.aFieldset>
                                        </div>
                                        <div className="col-6" colWidth={4} >
                                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DECORRENZA_MAX_RINNOVI', 'Giorni Decorrenza Max Rinnovi')}>
                                                <b> {this.props.prodotto.ggDecorrezzaMaxRinnovi ? this.props.prodotto.ggDecorrezzaMaxRinnovi : "-"} </b>
                                            </agui.aFieldset>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_MORA_EMISSIONE', 'Giorni Mora Emissione')}>
                                            <b> {this.props.prodotto.ggMoraEmissione ? this.props.prodotto.ggMoraEmissione : "-"} </b>
                                        </agui.aFieldset>
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_MORA_RINNOVO', 'Giorni Mora Rinnovo')} >
                                            <b> {this.props.prodotto.ggMoraRinnovo ? this.props.prodotto.ggMoraRinnovo : "-"} </b>
                                        </agui.aFieldset>
                                    </div>

                                    <div className="row">
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_DISDETTABILITA', 'Giorni disdettabilità')}>
                                            <b> {this.props.prodotto.ggDisdettabilita ? this.props.prodotto.ggDisdettabilita : "-"} </b>
                                        </agui.aFieldset>
                                        <agui.aFieldset className="col-6" title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNO_FINE_ADESIONE', 'Giorno Fine Adesione')} >
                                            <b>  {this.props.prodotto.giornoFineAdesione ? this.props.prodotto.giornoFineAdesione : "-"} </b>
                                        </agui.aFieldset>
                                    </div>

                                </agui.AccordionBody>
                            </agui.Accordion>
                        </div>
                    </div>

                    <div className="row">


                        <div className="col-2"  >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.CODICE', 'Codice')}>

                                <b> {this.props.prodotto.codice ? this.props.prodotto.codice : "-"} </b>
                            </agui.aFieldset>
                        </div>

                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.NUMERO_POLIZZA_BASE', 'Numero Polizza Base')}>
                                <b>   {this.props.prodotto.numeroPolizzaBase ? this.props.prodotto.numeroPolizzaBase : "-"} </b>
                            </agui.aFieldset>
                        </div>

                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.NUOVO_NUMERO_POLIZZA_RINNOVO', 'Nuovo numero polizza al rinnovo')}>
                                <b> {this.props.prodotto.flNuovoNumeroRinnovo ? "SI" : "NO"} </b>
                            </agui.aFieldset>
                        </div>

                        <div className="col-6" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.FILE_REGOLA', 'Nome File Regola')}>
                                <b> {this.props.prodotto.nomeFileRegola ? this.props.prodotto.nomeFileRegola : "-"} </b>
                            </agui.aFieldset>
                        </div>
                    </div>



                    <div className="row">

                        <div className="col-2"  >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.UMR', 'Unique Market Reference (UMR)')}>
                                <b>   {this.props.prodotto.uniqueMarketReference ? this.props.prodotto.uniqueMarketReference : "-"} </b>
                            </agui.aFieldset>
                        </div>

                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.RANKING', 'Ranking')}>
                                <b>   {this.props.prodotto.ranking ? this.props.prodotto.ranking : "-"} </b>
                            </agui.aFieldset>
                        </div>

                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.MODALITA_RATINO', 'Modalità Ratino')}>
                                <b> {this.props.prodotto.modalitaRatino ? ApplicationData.domainVal('AI_MODALITA_RATINO', this.props.prodotto.modalitaRatino).desDom : "-"} </b>
                            </agui.aFieldset>
                        </div>
                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.CALCOLO_PROVV_PASSIVE', 'Calcolo Provvigioni Passive')}>
                                <b>   {this.props.prodotto.modalitaCalcoloProvvPassive ? ApplicationData.domainVal('AI_MODALITA_PROVV_PASSIVE', this.props.prodotto.modalitaCalcoloProvvPassive).desDom : "-"} </b>
                            </agui.aFieldset>
                        </div>
                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.GIORNI_RIPENSAMENTO_LABEL', 'Giorni Ripensamento')}>
                                <b> {this.props.prodotto.ggRipensamento ? this.props.prodotto.ggRipensamento : "-"} </b>
                            </agui.aFieldset>
                        </div>
                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.RAMO', 'Id Ramo')}>
                                <b> {this.props.prodotto.idRamo ? this.props.prodotto.idRamo : "-"} </b>
                            </agui.aFieldset>
                        </div>

                    </div>
                    <div className="row">
                        {isAuth("PRODUCT_VIEW_TARIFFE") &&
                            <>
                                <div className="col-2"  >
                                    <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_CMP', 'Codice prodotto compagnia')}>
                                        <b>    {this.props.prodotto.codProdottoCmp} </b>
                                    </agui.aFieldset>
                                </div>

                                <div className="col-2" colWidth={4} >
                                    <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_BANCA', 'Codice prodotto banca')}>
                                        <b>  {this.props.prodotto.codProdottoBanca} </b>
                                    </agui.aFieldset>
                                </div>
                            </>
                        }

                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.DIVISA', 'Divisa')}>
                                <b>  {this.props.prodotto.codProdottoDiv ? ApplicationData.domainVal('COD_DIVPORT', this.props.prodotto.codProdottoDiv).desDom : "-"} </b>
                            </agui.aFieldset>
                        </div>
                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_TARIFFA', 'Codice Tariffa')}>
                                <b>  {this.props.prodotto.codTariffa} </b>
                            </agui.aFieldset>
                        </div>
                        {isAuth('PRODUCT.VIS_SEGNALATORE') ?
                            <div className="col-2" colWidth={4} >
                                <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.CAMPO_PROVVIGIONI', ' % Provvigioni')}>
                                    <b>  {this.props.prodotto.provvigioni} </b>
                                </agui.aFieldset>
                            </div>
                            : null}

                        {isAuth('PRODUCT.VIS_SEGNALATORE') ?
                            <div className="col-2" colWidth={4} >
                                <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.CAMPO_SEGNELATORE', ' % Segnelatore')}>
                                       {this.props.listaSegnelatori?.map((element, index) => {
                                                    if (!isNullOrUndefined(element) && !isNullOrUndefined(this.props.prodotto.idOperatoreSegn)  && element[0] === this.props.prodotto.idOperatoreSegn) {
                                                        return <><b>{element[1]}</b></>
                                                    }
                                                })}
                                </agui.aFieldset>
                            </div>
                            : null}


                        {this.props.prodotto.microCategoria !== null && this.props.prodotto.microCategoria !== undefined && this.props.prodotto.microCategoria.microCategoriaPacchetto === true ?
                            <div className="col-2" colWidth={4} >
                                <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.NUOVO_PRODOTTO_SOLUZIONE', 'Prodotto Soluzione')}>
                                    <b>  {this.props.prodotto.flProdottoSoluzione ? "SI" : "NO"} </b>
                                </agui.aFieldset>
                            </div>
                            :
                            null

                        }

                        {this.props.prodotto && this.props.prodotto.flAssicurazioneCongiunta === true &&
                            <div className="col-2" colWidth={4} >
                                <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.ASSICURAZIONE_CONGIUNTA', 'Assicurazione Congiunta')}>
                                    <b>  {this.props.prodotto.flAssicurazioneCongiunta ? "SI" : "NO"} </b>
                                </agui.aFieldset>
                            </div>
                        }

                        {this.props.prodotto && this.props.prodotto.flServizioDoPrint &&
                            <div className="col-2" colWidth={4} >
                                <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.RISCHIOLLOYDS', 'Rischio Lloyds')}>
                                    <b>  {this.props.prodotto.idRischioLloyds ? descRiscLloyds : "-"} </b>
                                </agui.aFieldset>
                            </div>
                        }
                    </div>


                    <div className="row">
                        <div className="col-2"  >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.INSERITO_DA', 'Inserito da')}>
                                <b>    {this.props.prodotto.insertUser} </b>
                            </agui.aFieldset>
                        </div>

                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da')}>
                                <b>  {this.props.prodotto.updateUser} </b>
                            </agui.aFieldset>
                        </div>
                        {/* </div>
                    <div className="row"> */}
                        <div className="col-2"  >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.DATA_INSERIMENTO', 'Data Inserimento')}>
                                <b>  {DateFormatter.dataFormatter(this.props.prodotto.insertDate)} </b>
                            </agui.aFieldset>
                        </div>
                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.SHARED.DATA_MODIFICA', 'Data Modifica')}>
                                <b> {DateFormatter.dataFormatter(this.props.prodotto.updateDate)}</b>
                            </agui.aFieldset>
                        </div>
                        <div className="col-2" colWidth={4} >
                            <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_EMAIL', 'Email Compagnia')}>
                                <b>   {this.props.prodotto.emailCompagnia ? this.props.prodotto.emailCompagnia : "-"} </b>
                            </agui.aFieldset>
                        </div>
                        {opt("APP", "FL_VIEW_AUTH_ABILITAZIONE", "false") === "true" &&
                            <div className="col-4" colWidth={4} >
                                <agui.aFieldset title={i18n('ARM_CORE_PRODUCT.PRODOTTO.COD_PRODOTTO_AUTH_ABILITAZIONE', 'Auth Abilitazione')}>
                                    <b>  {this.props.prodotto.authAbilitazione} </b>
                                </agui.aFieldset>
                            </div>
                        }
                    </div>
                </Layout.VBox>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        listaSegnelatori: state.prodotto.listaSegnelatori,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListaSegnelatori() {
            return dispatch(ProdottoActions.getListaSegnelatori());
        },
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ProdottoDetailsCard);
